import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {VisuallyHidden} from '../../../../libs/shared/ui/src/components/visuallyHidden/visuallyHidden';
import {ThemeContextType} from '../../../../libs/shared/ui/src/theme/userThemeProvider';

/*
 * Props.
 */

interface DropdownItemSecondaryIconProps {
  label: ReactNode;
  iconName: IconName;
  color?: string;
  isChecked?: boolean;
}

/*
 * Style.
 */

interface DropdownItemSecodaryIconStyleProps {
  $color?: string;
  $isChecked?: boolean;
}
const StyledIconDiv = styled.div<DropdownItemSecodaryIconStyleProps>`
  grid-area: right-icon;
  margin-left: 8px;
  width: 20px;
  height: 20px;

  color: ${(p) => buildIconColor(p)};

  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

function buildIconColor(props: DropdownItemSecodaryIconStyleProps & ThemeContextType) {
  // If a color was provided, always use it.
  if (props.$color) {
    return props.$color;
  }

  // If we're currently checked, display the accent.
  if (props.$isChecked) {
    return props.theme.greys.shade90;
  }

  // Otherwise, default to grey.
  return props.theme.greys.shade60;
}

/*
 * Component.
 */

export const DropdownItemSecondaryIcon: FC<DropdownItemSecondaryIconProps> = (props) => (
  <StyledIconDiv $color={props.color} $isChecked={props.isChecked}>
    <Icon name={props.iconName} />
    <VisuallyHidden>{props.label}</VisuallyHidden>
  </StyledIconDiv>
);
